namespace RioERP.Administration {
    export interface UserListRequest extends Serenity.ListRequest {
    }
}
